import { createStackNavigator } from "@react-navigation/stack"
import type { ContactAttendanceAnswerStackParamList } from "src/types.d"

export const ContactAttendanceAnswerStack = createStackNavigator<ContactAttendanceAnswerStackParamList>()
